import { SigilDocument } from "./sigil";

export const DEFAULT_TRADEMARK = "0,000,000";

export type CsvProductRow = {
  [K in keyof UploadProduct]?: string | null | undefined;
} & Record<string, string | null | undefined>;

export interface UploadProduct {
  name: string;
  sku: string;
  amazonId: string;
  upc?: string;
  brand?: string;
  map?: string;
  trademark?: string;
}

export interface ProductUploadResult {
  valid: UploadProduct[];
  warnings: ProductWarning[];
  errors: ProductError[];
  duplicatesRemoved: number;
}

export interface ProductWarning {
  row: number;
  product: string;
  message: string;
}

export interface ProductError {
  row: number;
  data: CsvProductRow;
  message: string;
}
interface ProductProps {
  images: string[];
  mapPrice: number;
  model: string | null;
  primaryImg: string;
  sku: string | null;
  trademark: string;
  upc: string | null;
}

export type ProductDocument = SigilDocument<ProductProps, { status: string }>;
